module.exports = __webpack_public_path__ + "static/media/emoji3.d02b4d80.png";